import React from 'react';
import Modal from '@material-ui/core/Modal';
import ClearIcon from '@material-ui/icons/Clear';

import { ModalWrapper, ModalDescription, SignInButton } from './styles';
import { useDispatch  } from "react-redux";
import { useHistory } from 'react-router-dom';

export function AccessExistsModal({ isModalOpen, handleClose }) {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      aria-labelledby="success-modal-title"
      aria-describedby="success-modal-description"
      disableBackdropClick 
    >
      <ModalWrapper>
        <ModalDescription id="success-modal-description">
          Este usuário já possui acesso ao MAP. Faça o login ou clique em "esqueci minha senha".
          <ClearIcon style={{ color: '#E8454F', fontSize: '30px' }} />
        </ModalDescription>
        <SignInButton type="button" onClick={() => { 
          dispatch({ type: "SET_STEP", step: 0 });
          history.push('/acessar')
        }}>
          <span> Fazer login</span>
        </SignInButton>
      </ModalWrapper>
    </Modal>
  );
}
